import React from "react";
import PropTypes from 'prop-types';
import { Col, Container, Row, Image, Modal } from "react-bootstrap";
import { Card, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { NumericFormat } from 'react-number-format';
import './LoanProtectionQuoteCard.scss';

export default function LoanProtectionQuoteCard(props) {
    const modalInfo = props.modalQuoteInfo;
    const hasRating =
        modalInfo.ratingAMBest ||
        modalInfo.ratingSP ||
        modalInfo.ratingMoodys ||
        modalInfo.ratingFitch ||
        modalInfo.ratingComdex;

    return (
        <Modal {...props} className='quote-info-modal' aria-labelledby="quote-info-modal" size="lg">
            <Modal.Body className="show-grid">
                <Container>
                    <Row className="float-end">
                        <IconButton className='p-0' aria-label="close" onClick={props.onHide} size="large">
                            <CloseIcon />
                        </IconButton>
                    </Row>
                    <Row>
                        <Image className='image-property' src={modalInfo.logoUrl} alt={'Americo Logo'} />
                    </Row>
                    <Row className={`rating primary-color`}>
                        {modalInfo.rating} Rating
                    </Row>
                    <Row className='productName'>
                        {modalInfo.productName}
                    </Row>
                    <Row className='veribage-text'>
                        As low as
                    </Row>
                    <Row>
                        <Col xs="3" md="9">
                            <Stats monthlyRate={modalInfo.monthlyRate} modalInfo={modalInfo}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="product-details-info ps-0">
                            {modalInfo.productDescription}
                        </Col>
                        <Col className='product-information'>
                            Product Information
                            <div className='product-information-elements'>
                                <ul dangerouslySetInnerHTML={{ __html: modalInfo.productInformation }} />
                            </div>
                        </Col>
                    </Row>
                    {hasRating && (
                        <div className="ratings">
                            <Row className='insurance-carrier-text'>
                                Insurance Company Ratings
                            </Row>
                            <Row>
                                <ul className="d-flex rating-cards">
                                    {modalInfo.ratingAMBest && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/ambest.jpg" rater="AM Best" rating={modalInfo.ratingAMBest} />
                                        </li>
                                    )}
                                    {modalInfo.ratingSP && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/sp.jpg" rater="S&amp;P Global" rating={modalInfo.ratingSP} />
                                        </li>
                                    )}
                                    {modalInfo.ratingMoodys && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/moodys.jpg" rater="Moody's" rating={modalInfo.ratingMoodys} />
                                        </li>
                                    )}
                                    {modalInfo.ratingFitch && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/fitch.jpg" rater="Fitch" rating={modalInfo.ratingFitch} />
                                        </li>
                                    )}
                                    {modalInfo.ratingComdex && (
                                        <li>
                                            <ProductDetailsRatingCard logo="/logos/ratings/comdex.jpg" rater="Comdex" rating={modalInfo.ratingComdex} />
                                        </li>
                                    )}
                                </ul>
                            </Row>
                        </div>
                    )}
                </Container>
            </Modal.Body>
        </Modal>
    );
}
const ProductDetailsRatingCard = (props) => {
    return (
        <Card className="rating-card">
            <div className="rating-card-head">
                <img src={props.logo} alt={props.rater} className="img-fluid" />
            </div>
            <p className="rater">{props.rater}</p>
            <p className={`insurance-carrier-rating primary-color`}>{props.rating}</p>
        </Card>
    );
};
const Stats = (props) => {
    return (
        <div className="product-details-stats">
            <Row>
                <Col className="ps-0">
                    <p>
                        <NumericFormat
                            className="quote-amount-dollars"
                            value={props.monthlyRate}
                            displayType={'text'}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                        />
                        <span className="quote-amount-mo">/mo</span>
                    </p>
                </Col>

                <Col>
                    <p className="stat-title">Typically Takes</p>
                    <p className={`stat-text primary-color`}>{props.modalInfo.underwritingTimeTypical}</p>
                </Col>

                <Col>
                    <p className="stat-title">Medical Exam</p>
                    <p className={`stat-text primary-color`}>{props.modalInfo.requiresMedicalExam}</p>
                </Col>
            </Row>
        </div>
    );
};

LoanProtectionQuoteCard.propTypes = {
    modalInfo: PropTypes.object,
    modalQuoteInfo: PropTypes.object,
    onHide: PropTypes.func,
    logo: PropTypes.string,
    rater: PropTypes.string,
    rating: PropTypes.string,
    monthlyRate: PropTypes.number,
};
ProductDetailsRatingCard.propTypes = {
    logo: PropTypes.string,
    rater: PropTypes.string,
    rating: PropTypes.string,
};
Stats.propTypes = {
    modalInfo: PropTypes.object,
    monthlyRate: PropTypes.number,
};
